import CategoryView from '../category/CategoryView';
import { usePageMeta } from '@/hooks/usePageMeta';
import { categories } from '@/mocks/comics';

export default function Fantasy() {
  const meta = categories[0];
  usePageMeta({
    title: '韩漫网奇幻漫画分类直达 - 韩漫漫画网',
    description: '韩漫网奇幻漫画分类：穿越异界、龙与魔法、热血冒险一站直达。韩漫漫画网聚合奇幻题材热门作品，分类清晰，点开即看。',
    keywords: '韩漫漫画网,韩漫网奇幻漫画,奇幻韩漫,异世界韩漫,韩漫题材分类',
    canonical: 'https://lovecomix.github.io/fantasy',
  });
  return <CategoryView type="fantasy" />;
}